'use strict';

awardData.classy.controller({
    name: 'AwardDataEstatesController',
    inject: ['$scope', '$q', 'ApplicationService', 'RealEstateModelFactory', '$timeout', '$http', 'zillowDataModelFactory', '$sce', 'HousingService', 'SliderService', 'SliderFactory', 'CalculationService'],
    init: function()
    {
        this.$.familyIndex = this.ApplicationService.getFamilyNo();
        this.model = new this.RealEstateModelFactory(this.ApplicationService.getFamilyData().data[0].familyID);
        this.$.ApplicationService = this.ApplicationService;
        this.$.versionNo = versionNo;
        this.$.items = this.ApplicationService.getFamilyData().real_estate;
        this.$.showEdit = false;
        this.zillowData = [];
        this.$.zillow = []; 
        this.$.ZillowDataModelService = new this.zillowDataModelFactory(this.ApplicationService.getFamilyData().data[0].familyID);
        this.ZillowDataModelService = this.$.ZillowDataModelService;
        this.$.compare = false;
        this.$.yesNo = {0: 'No', 1: 'Yes'};
        this.$timeout(function() {
            $(window).on('resize', function() {
                var height = $(this).height() - 206;
                var slideoutTabWidth = $(".slideout-tabs").width();
                $(".slideout-tabs .nav-tabs").css("width", slideoutTabWidth + 'px');
            }).trigger('resize');
        }, 100);
        this.$timeout(function() {
            $(window).on('resize', function() {
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".other-real-estate").css("margin-top", slideoutTabHeight + 'px');
            }).trigger('resize');
        }, 100);
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;

        //get and organize data
        this.$.familyHomeIndex = -1;
        var family_data = this.ApplicationService.getFamilyData().data[0];
        this.$.opened = [];
        this.edited = [];
        for (var i = 0; i < this.$.items.length; i++)
        {
            this.$.items[i].active = (i === 0);
            if (this.$.items[i].Rea_Description === "Family Home")
            {
                this.$.familyHomeIndex = i;
                this.$.items[i].Rea_Addy1 = family_data.Fam_Addy1;
                this.$.items[i].Rea_City = family_data.Fam_City;
                this.$.items[i].Rea_State = family_data.Fam_State_Prov;
                this.$.items[i].Rea_Zip = family_data.Fam_Zip;
                this.$.items[i].Rea_Country = family_data.Fam_Country;
                this.$.items[i].xRea_Addy1 = family_data.Fam_Addy1;
                this.$.items[i].xRea_City = family_data.Fam_City;
                this.$.items[i].xRea_State = family_data.Fam_State_Prov;
                this.$.items[i].xRea_Zip = family_data.Fam_Zip;
                this.$.items[i].xRea_Country = family_data.Fam_Country;
            }

            this.$.opened[i] = false;
            this.edited[i] = false;

            this.getZillowData(i);
            this.$.originalHousing = this.HousingService.getOrignalHousing();
            this.$.items[i].deleted = 0;
        }
        this.$.isEdited = [];
        for (var j = 0; j < this.$.items.length; j++) {
            if (this.$.items[j].Reh_Addy1 === this.$.items[j].xReh_Addy1 && this.$.items[j].Rea_City === this.$.items[j].xRea_City &&
                this.$.items[j].Rea_Country === this.$.items[j].xRea_Country && this.$.items[j].Rea_Description === this.$.items[j].xRea_Description &&
                this.$.items[j].Rea_Home_Ins === this.$.items[j].xRea_Home_Ins && this.$.items[j].Rea_Mort_Interest === this.$.items[j].xRea_Mort_Interest &&
                this.$.items[j].Rea_Mort_Pay === this.$.items[j].xRea_Mort_Pay && this.$.items[j].Rea_Mort_Val === this.$.items[j].xRea_Mort_Val &&
                this.$.items[j].Reh_PMV === this.$.items[j].xReh_PMV && this.$.items[j].Rea_Principle === this.$.items[j].xRea_Principle &&
                this.$.items[j].Rea_Property_Tax === this.$.items[j].xRea_Property_Tax && this.$.items[j].Rea_Property_Inc === this.$.items[j].xRea_Property_Inc &&
                this.$.items[j].Rea_Purch_Price === this.$.items[j].xRea_Purch_Price && this.$.items[j].Rea_Refinanced === this.$.items[j].xRea_Refinanced &&
                this.$.items[j].Rea_Refinanced_Amt === this.$.items[j].xRea_Refinanced_Amt && this.$.items[j].Rea_Refinanced_Year === this.$.items[j].xRea_Refinanced_Year &&
                this.$.items[j].Rea_State === this.$.items[j].xRea_State && this.$.items[j].Rea_Year_Purch === this.$.items[j].xRea_Year_Purch &&
                this.$.items[j].Rea_Zip === this.$.items[j].xRea_Zip) {
                this.$.isEdited[j] = false;
            }
            else {
                this.$.isEdited[j] = true;
            }
        }
    },
    watch: {
        'this.SliderService.returnSliders()': function(oldValue, newValue) {
            if (this.$.SliderService.returnSliders().length > 0) {
                for (var j = 0; j < this.$.SliderService.returnSliders().length; j++) {
                    if (this.$.SliderService.returnSliders()[j].partial.indexOf("state") >= 0) {
                        var ind = this.$.SliderService.returnSliders()[j].paramObj.tab
                    }
                }
                for (var i = 0; i < this.$.items.length; i++) {
                    if (ind!==undefined) {
                        this.$.items[ind].active = true;
                    }
                    else {
                        this.$.items[i].active = false;
                    }
                }
                
            }
        }
    },
    getOpened: function(index)
    {
        return this.$.opened[index]; 
    },
    toggleOpen: function(index)
    {
        if (this.zillowData[index] === undefined && typeof this.$.items[index].recordID != 'undefined')
            this.getZillowData(index);
        else
            this.$.zillow[index] = this.zillowData[index];
        this.$.opened[index] = !this.$.opened[index];
    },
    toggleCompare: function()
    {
        this.$.compare = !this.$.compare;
    },
    dismiss: function()
    {
        this.ApplicationService.getFamilyData().real_estate.pop(); 
    },
    toggleFamilyHomeEdit: function()
    {
        if (this.$.familyHomeIndex == -1)
            this.$.familyHomeIndex = this.model.newFamilyHome();
        this.edited[this.$.familyHomeIndex] = !this.edited[this.$.familyHomeIndex];
    },
    hasBeenEdited: function(item) {
        return (item.xRea_Year_Purch !== item.Rea_Year_Purch ||
        item.xRea_Mort_Pay !== item.Rea_Mort_Pay ||
        item.xRea_Mort_Val !== item.Rea_Mort_Val ||
        item.xRea_Mort_Interest !== item.Rea_Mort_Interest ||
        item.xRea_Purch_Price !== item.Rea_Purch_Price ||
        item.xRea_PMV !== item.Rea_PMV ||
        item.xRea_Principle !== item.Rea_Principle ||
        item.xRea_Property_Tax !== item.Rea_Property_Tax ||
        item.xRea_Refinanced !== item.Rea_Refinanced ||
        item.xRea_Refinanced_Year !== item.Rea_Refinanced_Year ||
        item.xRea_Refinanced_Amt !== item.Rea_Refinanced_Amt ||
        item.xRea_Addy1 !== item.Rea_Addy1 ||
        item.xRea_City !== item.Rea_City ||
        item.xRea_State !== item.Rea_State ||
        item.xRea_Zip !== item.Rea_Zip ||
        item.xRea_Country !== item.Rea_Country);
    },
    newEstate: function(home, $event)
    {
        $event.preventDefault();
        $event.stopPropagation();
        var family_data = this.ApplicationService.getFamilyData().data[0];
        var ind = this.model.new();
        this.$.items = this.ApplicationService.getFamilyData().real_estate;
        this.$.items[ind].active = 1;
        if (home === 1) {
            this.$.items[ind].Rea_Description = 'Family Home';
            this.$.items[ind].Rea_Addy1 = family_data.Fam_Addy1;
            this.$.items[ind].Rea_City = family_data.Fam_City;
            this.$.items[ind].Rea_State = family_data.Fam_State_Prov;
            this.$.items[ind].Rea_Zip = family_data.Fam_Zip;
            this.$.items[ind].Rea_Country = family_data.Fam_Country;
        }
        this.edited[ind] = true;
        this.$timeout(function() {
            var $window = $(window).on('resize', function() {
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".other-real-estate").css("margin-top", slideoutTabHeight + 'px');
            }).trigger('resize');
        }, 100);
    },
    isFieldEdited: function(item, field)
    {
        if (item['x' + field] === null || item[field] == item['x' + field])
            return false;
        else
            return true;
    },
    getField: function(item, field)
    {
        if (item['x' + field] == '' || item['x' + field] == undefined || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    getEdited: function(index)
    {
        return this.edited[index];
    },
    getZillowData: function(index)
    {
        this.$.zillow[index] = {};
        this.$.zillow[index].loading = true;
        var self = this;
        var recordID = this.$.items[index].recordID;
        if (this.$.items[index].Rea_Country == "United States" || this.$.items[index].xRea_Country == "United States" || this.$.items[index].Rea_Country == "UnitedStates" || this.$.items[index].xRea_Country == "UnitedStates" || this.$.items[index].Rea_Description == "Family Home") { //only display zestimate in US
            this.ZillowDataModelService.resolveData(recordID).then(function(data)
            {
                self.$.zillow[index].code = data[0].data.message.code;
                if (self.$.zillow[index].code  == "0")
                {
                    if (self.ZillowDataModelService.get(self.$.familyIndex).response.results.result[0])
                        var zillowResponse = self.ZillowDataModelService.get(self.$.familyIndex).response.results.result[0];
                    else 
                        var zillowResponse = self.ZillowDataModelService.get(self.$.familyIndex).response.results.result;
                    self.$.zillow[index].address = self.ZillowDataModelService.get(self.$.familyIndex).request.address;
                    self.$.zillow[index].link = zillowResponse.links.homedetails;
                    self.$.zillow[index].amount = zillowResponse.zestimate.amount;
                    self.$.zillow[index].high = zillowResponse.zestimate.valuationRange.high;
                    self.$.zillow[index].low = zillowResponse.zestimate.valuationRange.low;
                    var lat = zillowResponse.address.latitude;
                    var long = zillowResponse.address.longitude;
               }
               else {
                    var address = self.getField(self.$.items[index], 'Rea_Addy1') + '+'
                        + self.getField(self.$.items[index], 'Rea_City') + '+'
                        + self.getField(self.$.items[index], 'Rea_State') + '+'
                        + self.getField(self.$.items[index], 'Rea_Zip') + '+'
                        + self.getField(self.$.items[index], 'Rea_Country');
                    address = address.replace(" ", "+");
                    self.$.zillow[index].code = 0;
                }
                self.$.zillow[index].loading = false;
                self.zillowData[index] = self.$.zillow[index];
            });
        }
        var address = this.getField(this.$.items[index], 'Rea_Addy1') + '+'
            + this.getField(this.$.items[index], 'Rea_City') + '+'
            + this.getField(this.$.items[index], 'Rea_State') + '+'
            + this.getField(this.$.items[index], 'Rea_Zip') + '+'
            + this.getField(this.$.items[index], 'Rea_Country');
        address = address.replace(" ", "+");
        this.$.zillow[index].googlePic = "https://maps.googleapis.com/maps/api/streetview?size=600x300&location=" + address + "&key=AIzaSyDJkbn5RIfAaM25Hs_Cx3gdh01W-vvuaDc";
        this.$.zillow[index].code = 0;
        this.$.zillow[index].loading = false;
        this.zillowData[index] = this.$.zillow[index]; 
    },
    startSaveProcess: function(scope, instance, form, index)
    {
        this.$.index = index;
        if (form.$valid)
        {
            this.edited[index] = !this.edited[index]
            instance.options.factor = 0.5;
            this.$.putObject = angular.copy(this.$.items[index]);
            var parent = this;
            // editing existing real estate
            if ((typeof this.$.putObject.recordID !== 'undefined')) {
                // If it's a Family Home, send the address info to the family table and strip it from the real estate putObject
                if (this.$.putObject.Rea_Description=='Family Home') { 
                    this.$.famPutObject = {'familyID': this.$.putObject.familyID, 'Fam_Addy1': this.$.putObject.xRea_Addy1, 'Fam_City': this.$.putObject.xRea_City, 'Fam_State_Prov': this.$.putObject.xRea_State
                                            , 'Fam_Zip': this.$.putObject.xRea_Zip, 'Fam_Country': this.$.putObject.xRea_Country};
                    delete this.$.putObject.Rea_Addy1
                    delete this.$.putObject.Rea_City
                    delete this.$.putObject.Rea_State
                    delete this.$.putObject.Rea_Zip
                    delete this.$.putObject.Rea_Country
                    delete this.$.putObject.xRea_Addy1
                    delete this.$.putObject.xRea_City
                    delete this.$.putObject.xRea_State
                    delete this.$.putObject.xRea_Zip
                    delete this.$.putObject.xRea_Country

                    var queue = [];
                    var deferred = this.$q.defer();
                    queue.push(this.model.put(this.$.putObject.recordID, this.$.putObject, instance));
                    queue.push(this.$http.put("/api/family/"+this.$.famPutObject.familyID, this.$.famPutObject));
                    this.$q.all([queue]).then(function (results) {
                        deferred.resolve(results);
                        parent.$.items[index].Rea_Addy1 = parent.$.famPutObject.Fam_Addy1;
                        parent.$.items[index].Rea_City = parent.$.famPutObject.Fam_City;
                        parent.$.items[index].Rea_State = parent.$.famPutObject.Fam_State_Prov;
                        parent.$.items[index].Rea_Zip = parent.$.famPutObject.Fam_Zip;
                        parent.$.items[index].Rea_Country = parent.$.famPutObject.Fam_Country;
                        parent.$.items[index].xRea_Addy1 = parent.$.famPutObject.Fam_Addy1;
                        parent.$.items[index].xRea_City = parent.$.famPutObject.Fam_City;
                        parent.$.items[index].xRea_State = parent.$.famPutObject.Fam_State_Prov;
                        parent.$.items[index].xRea_Zip = parent.$.famPutObject.Fam_Zip;
                        parent.$.items[index].xRea_Country = parent.$.famPutObject.Fam_Country;
                    });
                    return deferred.promise;
                }
                else {
                    return this.model.put(this.$.putObject.recordID, this.$.putObject, instance)
                }
            }
            //adding new real estate, copy 'x' edit fields to original fields
            else {
                return this.model.post(this.id, this.$.putObject, instance);
                
            }
        }
        else
            instance.stop(-1);
    },
    successSave: function (scope, instance, index, callback)
    {
        this.edited[index] = !this.edited[index];
        var parent = this;
        this.CalculationService.reCalc();
        if(instance.options.data.id !== undefined)
        {
            this.$.items[index].recordID = instance.options.data.id;
        }
        if (typeof callback != 'undefined')
            callback();
    },
    startDeleteProcess: function(scope, instance, form, index)
    {
        var parent = this;
        instance.options.factor = 0.5;
        
        this.$.index = index;
        if (form.$valid)
        {
            swal({
                title: "Are you sure?",
                text: "This real estate will be permanently deleted, are you sure you want to delete this real estate?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD68BB",
                confirmButtonText: "Yes",
                closeOnConfirm: true
            },
            function(isConfirm) {
                if (isConfirm) {
                    parent.edited[index] = !parent.edited[index];
                    parent.$.items[index].deleted = 1;
                    return parent.model.purge(parent.$.items[index].recordID, parent.$.items[index], instance)
                    
                }
                else {
                    instance.stop(-1); 
                }
            });
        }
        else
            instance.stop(-1);   
    },
    successDelete: function (scope, instance, index)
    {
        this.edited[index] = !this.edited[index];
        this.$.items.splice(this.$.index, 1);
        this.ApplicationService.getFamilyData().real_estate.splice(this.$.index, 1);
        this.CalculationService.reCalc();
    }
});
